import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=2e9beb46&"
import script from "./Banner.js?vue&type=script&lang=js&"
export * from "./Banner.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Banner.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fhome%2FBanner%2FBanner.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports